import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import {ParentMixin} from '../../common/utils/relation';

var _createNamespace = createNamespace('checkbox-group'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    mixins: [ParentMixin('Checkbox')],
    name: getComponentName('CheckboxGroup'),
    props: {
        value: null
    },
    render: function render() {
        var h = arguments[0];
        return h(
            'div',
            {
                class: b()
            },
            [this.$slots.default]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
